module.exports = __webpack_public_path__ + "static/media/benessere.3c0ac066.jpg";